import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

let isBrGridInit = false;
let brGridElement = $('.js-bond-request-grid');

const getBrDataSource = () => {
  return new kendo.data.DataSource({
    transport: {
      read: {
        url: 'BondRequests', 
        dataType: 'json'
      },
      update: {
        url: 'SetBondRequestStatus',
        dataType: 'json'
      },
      parameterMap(data, type) {
        if(type !== 'update') return;
        return { 
          bondId: data.Id,
          isWon: data.Status
        };
      }
    }, 
    requestEnd(e) {
      if(e.type === 'update' && e.response) {
        const data = e.response[0];
        if(data.success !== true) {
          showErrorNotification(data.reason);
        } else {
          showSuccessNotification('Bond Request status updated!');
        }
      }
    },
    schema: {
      model: {
        id: 'Id', fields: {
          Id: {
            type: 'number',
            editable: false
          }, 
          IdFormatted: {
            type: 'string',
            editable: false
          }, 
          Creator: {
            type: 'string',
            editable: false
          }, 
          Type: {
            type: 'string',
            editable: false
          }, 
          ProjectName: {
            type: 'string',
            editable: false
          }, 
          Obligee: {
            type: 'string',
            editable: false
          }, 
          Amount: {
            type: 'number',
            editable: false
          }, 
          Status: {
            type: 'string',
            editable: true
          }, 
          ApprovalStatus: {
            type: 'string',
            editable: false
          },
          // Filled from the evaluated approval chain, one entry per tier of this request's
          // chain. The per-tier hasXApproval / xApproval fields it replaces are gone.
          Approvals: {
            editable: false
          },
          rejected: {
            type: 'boolean',
            editable: false
          },
          rejection: {
            type: 'string',
            editable: false
          }
        }
      }
    }, 
    pageSize: 15
  });
};

const openBondRequestInfo = (e) => {
  const $brGrid = brGridElement.data('kendoGrid');
  const dre = $(e.target).closest('tr[role="row"]');
  const dr = $brGrid.dataItem(dre);
  window.location.href = `/Sales/BondRequests/BondRequestInfo?id=${dr.Id}`;
};

const btValues = [{
  text: 'Payment/Performance', 
  value: 'Payment/Performance'
}, {
  text: 'Bid Guaranty & Contract',
  value: 'Bid Guaranty & Contract'
}, {
  text: 'Bid Bond', 
  value: 'Bid Bond'
}];
const bondTypeFilter = (e) => {
  e.kendoDropDownList({
    optionLabel: 'Select bond type...', 
    dataTextField: 'text', 
    dataValueField: 'value', 
    dataSource: btValues
  });
};

const approvalStatusFilter = (e) => {
  const approvalStatuses = [
    'Not Approved', 'Partially Approved', 'Approved', 'Rejected'
  ];
  e.kendoDropDownList({
    optionLabel: 'Select approval level...', 
    dataSource: approvalStatuses
  });
};

const brGridDataBound = (e) => {
  const grid = e.sender;
  const brOpenCells = $(grid.element).find('table[role="grid"] tbody tr[role="row"] td:not(.bond-request-status)');
  brOpenCells.unbind('click');
  brOpenCells.on('click', openBondRequestInfo);
  brOpenCells.css('cursor', 'pointer');
  const items = grid.items();
  items.each((i,item) => {
    const di = grid.dataItem(item);
    const ddt = $(item).find('input.bond-request-status');
    createStatusEditor(ddt, di);
  });
};

const hideFilterOperators = (c) => {
  c.find('[title="Operator"]').hide();
  c.find('[title="Additional operator"]').hide();
};

const brGridFilterMenuInit = (e) => {
  if (e.field === 'Type') hideFilterOperators(e.container);
  if (e.field === 'ApprovalStatus') hideFilterOperators(e.container);
};

const statusOptions = [{
  text: '',
  value: null
},{
  text: "Won",
  value: true
}, {
  text: "Lost",
  value: false
}];
const updateStatus = (e) => {
  const ddl = e.sender;
  const brGrid = brGridElement.data('kendoGrid');
  const dre = $(ddl.element).closest('tr[role="row"]');
  const dr = brGrid.dataItem(dre);
  dr.set('Status', ddl.value());
  brGrid.saveChanges();
};
const createStatusEditor = (obj, di) => {
  obj.attr('name', 'Status')
    .data('bond-request-id', di.Id);
  obj.kendoDropDownList({
      dataSource: statusOptions,
      dataTextField: "text",
      dataValueField: "value",
      value: di.Status,
      change: updateStatus
    });
};

const getTag = (hasApproval, approvalText) => {
  const tagClass = hasApproval ? 'tag--green' : 'tag--red';
  const tag = `<div class="tag tag--small-x ${tagClass}">${approvalText}</div>`;
  return tag;
}

const approvalStatusTemplate = (dataItem) => {
  const tags = [];

  dataItem.Approvals.forEach((item) => {
    tags.push(getTag(item.HasApproval, item.ApprovalText))
  });

  let output = '<div class="bond-request-approval-wrapper">'
    + tags.join('\r\n')
    + '</div>';

  return output;
};

const initBondRequestGrid = (ele) => {
  if (isBrGridInit) return;
  const brGridDataSource = getBrDataSource();
  ele.kendoGrid({
    dataSource: brGridDataSource, 
    columns: [
      {
        field: 'IdFormatted', 
        title: 'Bond Number', 
        editable: false,
        headerAttributes: {style: 'white-space: normal'}, 
        width: '7%'
      }, {
        field: 'Creator', 
        title: 'Creator', 
        editable: false,
        headerAttributes: {style: 'white-space: normal'}, 
        width: '15%'
      }, {
        field: 'Type', 
        title: 'Bond Type', 
        editable: false,
        filterable: {
          ui: bondTypeFilter, 
          operators: {
            string: {eq: 'Equals'}
          }
        }, 
        headerAttributes: {style: 'white-space: normal'}, 
        width: '10%'
      }, {
        field: 'ProjectName', 
        title: 'Project Name', 
        editable: false,
        headerAttributes: {style: 'white-space: normal'}, 
        width: '15%'
      }, {
        field: 'Obligee', 
        title: 'Obligee', 
        editable: false,
        headerAttributes: {style: 'white-space: normal'}, 
        width: '18%'
      }, {
        field: 'Amount',
        title: 'Bond Amount',
        editable: false,
        headerAttributes: {style: 'white-space: normal'},
        attributes: {style: 'text-align: right'},
        width: '10%',
        format: '{0:c2}'
      }, {
        field: 'Status',
        title: 'Status',
        editable: false,
        template: kendo.template('<input class="bond-request-status" style="width: 100%"/>'),
        headerAttributes: {style: 'white-space: normal'},
        attributes: {class: 'bond-request-status'},
        width: '10%'
      }, {
        field: 'ApprovalStatus', 
        title: 'Approval Status', 
        editable: false,
        filterable: {
          ui: approvalStatusFilter, 
          operators: {
            string: {eq: 'Equals'}
          }
        }, 
        headerAttributes: {style: 'white-space: normal'}, 
        template: approvalStatusTemplate, 
        width: '15%'
      }
    ], 
    dataBound: brGridDataBound, 
    filterMenuInit: brGridFilterMenuInit,
    sortable: true, 
    resizable: true, 
    pageable: {
      pageSizes: [5, 15, 25, 50, 100, 'all']
    }, 
    filterable: {
      operators: {
        number: {
          gte: '>=', gt: '>', lte: '<=', lt: '<', eq: '='
        }, string: {
          contains: 'Contains', 
          doesnotcontain: 'Doesn\'t Contain', 
          startswith: 'Starts With', 
          isempty: 'Is Empty'
        }
      }
    }
  });
  isBrGridInit = true;
};

export const bondRequestGridDisplay = (toShow) => {
  if (toShow == null) brGridElement.toggle();
  if (toShow) brGridElement.show();
  if (!toShow) brGridElement.hide();
};

export default () => {
  if (brGridElement == null) return;
  const $brGrid = brGridElement.data('kendoGrid');
  if ($brGrid == null) initBondRequestGrid(brGridElement);
};
